var render = function render(){var _vm=this,_c=_vm._self._c;return _c('echarts',{ref:"chart",staticClass:"chart",attrs:{"v-loading":_vm.loading,"element-loading-text":"Loading...","auto-resize":true,"initOptions":_vm.initOptions,"options":_vm.options},on:{"click":_vm.handleChartClick,"init":_vm.chartInit}})
}
var staticRenderFns = []

export { render, staticRenderFns }